import { Component, OnInit, HostBinding, 
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomerCustomerDemoData, CustomerCustomerDemoService }  from './CustomerCustomerDemo.service';

import { CustomersData, CustomersService } from '../Customers/Customers.service';

@Component({
  template: require('./CustomerCustomerDemoDetails.component.html'),
  providers: [CustomerCustomerDemoService
	, CustomersService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerCustomerDemoDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
  
	objCustomerCustomerDemo: CustomerCustomerDemoData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	CustomersList: CustomersData[];

	constructor(private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastsManager,
		private CustomerCustomerDemoService: CustomerCustomerDemoService
			, private  CustomersService:  CustomersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objCustomerCustomerDemo = new CustomerCustomerDemoData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.CustomerCustomerDemoService.getByID(+params['id']))
		.switchMap((params: Params) => this.CustomerCustomerDemoService.getByID(params['id']))
		.subscribe((item: CustomerCustomerDemoData) => this.objCustomerCustomerDemo = item);
		this.getLookups();
	}

	deleteCustomerCustomerDemo(id: number) {
		if (window.confirm('Are you sure you want to delete this CustomerCustomerDemo?') == true)
		{
			this.CustomerCustomerDemoService.deleteCustomerCustomerDemo(this.objCustomerCustomerDemo.CustomerID.toString())
			.subscribe(record => this.router.navigate(['/CustomerCustomerDemo']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('CustomerCustomerDemo record deleted successfully...'); }
			);
		}
	}
	gotoCustomerCustomerDemoEdit() {
		this.router.navigate(['/CustomerCustomerDemo', this.objCustomerCustomerDemo.CustomerID]);
	}

	gotoCustomerCustomerDemo() {
		this.router.navigate(['/CustomerCustomerDemo']);
	}

	// Get Lookup List for Customers
    getCustomers() {
		this.CustomersService.getAll().subscribe(records => this.CustomersList=records);
    }

	getLookups() {

        this.getCustomers();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerCustomerDemo/CustomerCustomerDemoDetails.component.ts